var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.305,
    height: 9.808,
    viewBox: "0 0 11.305 9.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8110",
    "data-name": "Path 8110",
    d: "M7.133,1.841l-2.8,2.8a1.011,1.011,0,0,0-.293.713v5.055a1.015,1.015,0,0,0,1.012,1.012H9.6a1.019,1.019,0,0,0,.931-.612l1.65-3.85a1.52,1.52,0,0,0-1.4-2.115H7.927l.481-2.317A.763.763,0,0,0,8.2,1.836a.753.753,0,0,0-1.068.005ZM2.012,11.424a1.015,1.015,0,0,0,1.012-1.012V6.364A1.012,1.012,0,0,0,1,6.364v4.048A1.015,1.015,0,0,0,2.012,11.424Z",
    transform: "translate(-1 -1.616)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like_icon.bee676b927a121e9faae4459f14ee590.svg";
export { ForwardRef as ReactComponent };